import React, { useContext, useState, useRef } from "react";
import ReactDOM from 'react-dom';
import { useTranslation } from "react-i18next";
import { Card, Col, Row } from "react-bootstrap"
import { ActionButton, IconButton, SpinnerSize } from "@fluentui/react";
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import { getGridLocalization, isNullUndefined, isNullUndefinedOrEmpty, showMessage } from "../../common/Helpers";
import MessageBox from "../../components/Common/Message/MessageBox";
import { __MessageTypes } from "../../common/Dictionaries";
import MainAppContext from "../../MainAppContext";
import MatrixToolbar from "../../components/Products/sPrivilege/Matrix/MatrixToolbar";
import * as XLSX from 'xlsx';
import { applyFilters, handlerFilter, setterActionFired, useFilterActionComponentData } from "../../common/Helpers/JqxGridFilter";
import { getIntegrationreport as getItem, addIntegrationreportList as addListItems, addIntegrationreport as addItem, saveIntegrationreport as saveItem, deleteIntegrationreport as deleteItem} from "../../services/sIntegration/integration.service";
import { useGetAllIntegrationreport as useGetAllItems } from "../../hooks/services/sIntegration/useOfIntegration";
import { orchestIntegrationKPI_SAPFG_Report } from "../../services/sKPI/integration.service";
import Loading from "../../components/Templates/Site/Loading";
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
export default function IntegrationReport() {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const profileHasAccess = !contextSite.onlyObserver || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)

    const gridRef = useRef();
    const fileInputRef = useRef(null);

    const [showRequiredGlobalMessage, setShowRequiredGlobalMessage] = useState(false);
    const [editingRows, setEditingRows] = useState([]);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [loading, setLoading] = useState(false);    

    const [listItems, setListItems] = useState(null);    
    useGetAllItems(listItems, setListItems);
    
    useFilterActionComponentData(gridRef, messageConfig, "IntegrationReport");

    const handlerAddNewRow = (obj) => {
        const records = gridRef.current.props.source.records;
        const _lowerId = records.length !== 0 ? records.reduce((min, obj) => obj.id < min ? obj.id : min, records[0].id) : 0;
        const lowerId = records.length === 0 ? -1 : (_lowerId > 0 ? ((_lowerId * -1) - 1) : _lowerId -1);

        const newRow = !obj ? {
            id:             lowerId,
            uri:            "",
            params:         "",
            dateFormat:     "",
            active:         true,            
        } : {
            id:             lowerId,
            uri:            obj.uri,
            params:         obj.params,
            dateFormat:     obj.dateFormat,
            active:         obj.active,            
        };

        gridRef.current.beginupdate();
        gridRef.current.addrow(null, newRow, 'first');

        listItems.unshift(newRow);
        setListItems(listItems);

        if (editingRows.length > 0 ? editingRows.find(x => x === lowerId) === undefined : true) {
            editingRows.push(lowerId);
            setEditingRows(editingRows);
        }

        gridRef.current.endupdate();
        gridRef.current.updatebounddata('rows');
        setterActionFired("IntegrationReport", 1);
    };
    
    const getValue = (column, row) => {
        const itemValue = column.editorOptions.find(x => x.key === row[column.dataField])

        return !isNullUndefinedOrEmpty(itemValue) ? itemValue.text : "";
    }

    const handlerExportData = (exportData) => {
        const workbook = XLSX.utils.book_new();
        const columns = getColumns()
        const aux_rows = []

        if (exportData) {
            const aux_list = listItems.filter(x => x.id > 0);

            aux_list.forEach(row => {
                let aux_row = {};
                columns.forEach(column => {
                    if (column.exportable) {
                        if (column.columntype === 'dropdownlist') {
                            aux_row[column.dataField] = row[column.dataField] !== null ? getValue(column, row) : "";
                        }
                        else {
                            aux_row[column.dataField] = row[column.dataField];
                        }
                    }
                });
    
                aux_rows.push(aux_row);
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(aux_rows, { header: columns.filter(x => (exportData ? x.exportable : x.uploadMasive)).map(column => column.dataField) });
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
        XLSX.writeFile(workbook, 'IntegrationReport_ExportedData.xlsx');
    };

    const isInValidFormControls = (list) => {
        let isInvalidForm = false;
        const validItems = [];

        list.forEach(element => {
            if (validateObject(element)) {
                validItems.push(element);
            }
            else {
                isInvalidForm = true;
            }
        });
    
        return {isInvalidForm: isInvalidForm, validItems: validItems};
    };
    
    const handlerSaveAll = async () => {
        const elementosFiltrados = listItems.filter(objeto => editingRows.includes(objeto.id));
        console.log(elementosFiltrados);

        const valid_response = isInValidFormControls(elementosFiltrados);

        if (valid_response.validItems) {
            await addListItems(valid_response.validItems).then(async (response) => {
                if (response.data.succeeded) {
                    setEditingRows([]);

                    listItems.forEach(element => {
                        const currentItem = response.data.data.find(x => x.id === element.id)
                        if (!isNullUndefined(currentItem)) {
                            element.params = currentItem.params;
                        }
                    });

                    const aux_items = [...listItems];

                    setListItems(aux_items);
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                }
                setterActionFired("IntegrationReport", 1);
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                setterActionFired("IntegrationReport", 1);
            });
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'));
        }
    };

    const handlerSave = async (itemId) => {       
        const item = gridRef.current.props.source.records.find(x => parseInt(x.id) === itemId);

        if (validateObject(item)) {
            if (item.id <= 0) {                

                await addItem(item).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id));

                        listItems.forEach(element => {
                            if (element.id === parseInt(item.id)) {
                                element.id = serviceResponse.data.data;
                                element.uri = item.uri;
                                element.params = item.params;
                                element.dateFormat = item.dateFormat;
                                element.active = item.active;
                            }
                        });
                                               
                        setListItems(listItems);
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                    }        
                    setterActionFired("IntegrationReport", 1);
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                    setterActionFired("IntegrationReport", 1);
                });
            }
            else {
                await saveItem(item.id, item).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id));

                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                    }  
                    setterActionFired("IntegrationReport", 1);
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                    setterActionFired("IntegrationReport", 1);
                });
            } 

            setShowRequiredGlobalMessage(false);
        }
        else {
            setShowRequiredGlobalMessage(true);
        }
    };

    const handlerDelete = async (itemId) => {        
        if (itemId <= 0) {
            const newListItems = gridRef.current.props.source.records.filter(x => x.id.toString() !== itemId.toString());
            setListItems(newListItems);
            setEditingRows(editingRows.filter(x => x.toString() !== itemId.toString()));
        }
        else {
            await deleteItem(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {                    
                    const newListItems = gridRef.current.props.source.records.filter(x => x.id.toString() !== itemId.toString());

                    setListItems(newListItems);
                    setEditingRows(editingRows.filter(x => x.toString() !== itemId.toString()));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                    
                    gridRef.current.updatebounddata('rows');                   
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                }
                setterActionFired("IntegrationReport", 1);
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                setterActionFired("IntegrationReport", 1);
            });
        }
    };

    const handlerCancel = async (itemId) => {
        if (itemId === null) {
            const newListItems = listItems.filter(x => x.id !== itemId);
            setListItems(newListItems);
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));    
            setterActionFired("IntegrationReport", 1);
        }
        else
        {
            await getItem(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    listItems.forEach(element => {
                        if (serviceResponse.data.data.id === element.id) {
                            for (const property in serviceResponse.data.data) {
                                element[property] = serviceResponse.data.data[property];
                            }
                        }
                    });
            
                    setListItems(listItems);
                    setEditingRows(editingRows.filter(x => x !== itemId));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                }
                setterActionFired("IntegrationReport", 1);
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                setterActionFired("IntegrationReport", 1);
            });
        }
    };

    const validateObject = (object) => {
        let isValid = object.uri !== undefined && object.uri !== null && object.uri !== '';       
        isValid = isValid ? (object.dateFormat !== undefined && object.dateFormat !== null && object.dateFormat !== '') : isValid;       

        return isValid;
    };

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return listItems[rowIndex.boundindex].id;
        }
        return listItems[rowIndex]?.id;
    };

    const handlerExecuteIntegrations = async () => {
        setLoading(true) 
        const items = gridRef.current.props.source.records.filter(x => x.selection === true).map(x => x.id);
            
        await orchestIntegrationKPI_SAPFG_Report(true, items).then((serviceResponse) => {
            if (serviceResponse.data.succeeded) {
                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))   
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
            setterActionFired("IntegrationVisor", 1)
            setLoading(false) 
        }).catch((error) => {
            if (error.response) {
                const statusCode = error.response.status;
                
                if (statusCode === 504) {
                    console.log('Error 504: Gateway Timeout - El servidor no respondió a tiempo');
                    showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-operationerror-integrationfg'))
                } else if (statusCode === 499) {
                    console.log('Error 499: Client Closed Request - El cliente cerró la conexión antes de la respuesta');
                    showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-operationerror-integrationfg'))
                } else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            } else if (error.request) {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            } else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }

            setterActionFired("IntegrationVisor", 1)
            setLoading(false) 
        });
    };

    const onCellvaluechanged = (e) => {

        listItems[e.args.rowindex][e.args.datafield] = e.args.value;
        
        const copia_listItems = JSON.parse(JSON.stringify(listItems));
        setListItems(copia_listItems);

        if (editingRows.find(x => x === listItems[e.args.rowindex].id) === undefined) {
            editingRows.push(listItems[e.args.rowindex].id);
        }

        setEditingRows(editingRows);
        applyFilters(gridRef, 'IntegrationReport', false);

        try {
            const gridContainer = gridRef.current;
            if (gridContainer) {

                const position = gridRef.current.scrollposition();
                const minimalScrollIncrement = 1;

                gridRef.current.scrolloffset(0, position.left + minimalScrollIncrement);
                gridRef.current.scrolloffset(0, position.left - minimalScrollIncrement);
            }
        } catch (error) {

        }
    };

    const actionCellsRenderer = (row) => {          
        const itemId = getRowIdFromRowIndex(row);
        const isEditing = editingRows.find(x => x === itemId);
        
        return  <>
                    {isEditing ? (
                        <>
                            {
                                itemId <= 0 ? (
                                    <>
                                        <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                        <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                    </>
                                ) : (
                                    <>
                                        <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                        <IconButton iconProps={{ iconName: 'Cancel' }} title="Cancelar" ariaLabel="Cancelar" onClick={() => fieldActionHandler(itemId, 'cancel')} />
                                        <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                    </>
                                )
                            }
                        </>
                    ) : (
                        <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                    )}
                </>
    };

    const fieldActionHandler = (itemId, actionType) => {
        switch (actionType) {
            case 'save':
                handlerSave(itemId);
                break;
            case 'delete':
                handlerDelete(itemId);
                break;
            case 'cancel':
                handlerCancel(itemId);
                break;
            default:
                break;
        }
    };

    const cellsRenderer = (rowIndex, cellValue, editor, cellText, width, height, auxListData, cellType, subType) => {
        switch (cellType) {
            case 'textbox':
                switch (subType) {
                    case "currency":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: false,
                            symbol: '$',
                            groupSeparator: ',',
                            decimalSeparator: '.',
                        });
                        break;
                    case "number":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: true,
                            groupSeparator: ',',
                            decimalSeparator: '.',
                        });
                        break;
                    default:
                        break;
                }
                break;
            case 'datetimeinput':
                break;
            case 'checkbox':
                editor.jqxCheckBox({ width: width });
                break;
                case 'dropdownlist':
                editor.jqxDropDownList({
                    width: width,
                    height: height,
                    source: getListColumnAdapter(auxListData, 'key', 'text'),
                    displayMember: 'text',
                    valueMember: 'key',
                    autoDropDownHeight: auxListData.length < 5
                });
            default:
                break;
        }
    };

    const getListColumnAdapter = (listObjetcs, key, text) => {
        return new jqx.dataAdapter({
            datafields: [
                { name: text, type: 'string' },
                { name: key, type: 'number' }
            ],
            datatype: 'array',
            localdata: listObjetcs
        }, { autoBind: true });
    };

    const cellRenderClassStyle = (row, columnfield, value, columnType) => {
        let className = "";
        switch (columnType) {
            case "blocked":
                className = 'jqx-custom-blocked';
                break;
            case "textbox":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "numberinput":
                if (value < 0 || value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "datetimeinput":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "dropdownlist":
                if (value === null || value === '' || value === 0) {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break
            default:
                break;
        }

        return className;
    };
    
    const getColumns = () => { 
        const basicColumns =[
            { index: null, text: 'Id', dataField: 'id', width: '0px', hidden: true, exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'),  columntype: 'textbox',  cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'), editable: profileHasAccess ?? false, pinned: true},
            { index: null, text: t('data-lang-lbl-select'),        dataField: 'selection',  width: '6%', pinned: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'checkbox', 'string'), columntype: 'checkbox',                 filtertype: 'bool', filterable: false, editable: true },
            { index: null, text: t('data-lang-lbl-actions'),       dataField: 'acciones',   uploadMasive: false, exportable: false, width: '7%', pinned: true, filterable: false,
                createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
            },
            
            { index: 0, text: t('data-lang-lbl-field-integrationReportCode'), dataField: 'integrationReportCode', width: '10%', exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) => cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox',  cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'blocked'), editable: false },
            { index: 1, text: t('data-lang-lbl-field-uri'),                   dataField: 'uri',                   width: '30%', exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) => cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox',  cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'), editable: profileHasAccess },
            { index: 2, text: t('data-lang-lbl-field-params'),                dataField: 'params',                width: '29%', exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) => cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox',  editable: profileHasAccess },
            { index: 3, text: t('data-lang-lbl-field-dateFormat'),            dataField: 'dateFormat',            width: '8%',  exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) => cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox',  cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'), editable: profileHasAccess },
            { index: 4, text: t('data-lang-lbl-field-active'),                dataField: 'active',                width: '10%', exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) => cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'checkbox', 'string'),columntype: 'checkbox', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'), editable: profileHasAccess },
        ]

        return basicColumns;
    };

    return (
        <div className="col-12 listWithActions h-100">
            <Card className="h-100">
                <Card.Header>
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>{t('data-lang-maintainer-title-integrationreport')}</b></h4>
                    </Card.Title>
                </Card.Header>
                <Card.Footer>
                    <MessageBox
                        inputParam_Message={ messageConfig.message }
                        inputParam_Display={ messageConfig.showMessage }
                        inputParam_MessageType={ messageConfig.messageType }
                        inputParam_SetterMessage={ setMessageConfig }
                    />
                </Card.Footer>
                <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                    <div className="align-items-center h-100">
                        <div className="d-none">                                                        
                            <a id="btnGetTemplateJson" href={undefined} download="Template.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                        </div>
                        {
                            listItems &&
                            <>
                                <Row>
                                    <Col></Col>
                                    <Col className="text-end col-auto">
                                        <MatrixToolbar
                                            inputParam_HandleSaveData={handlerSaveAll}                                    
                                            inputParam_HandleUploadData={undefined}
                                            inputParam_HandleExportData={handlerExportData}
                                            inputParam_HandleAddRow={handlerAddNewRow}
                                            inputParam_Configuration={{
                                                buttons: {
                                                    showRowButtons: false,
                                                    showExportData: profileHasAccess,
                                                    showAddMasiveData: false,
                                                    showAddData: profileHasAccess,
                                                    showDownloadTemplate: false,
                                                    showSaveAllData: profileHasAccess,
                                                    groupedButtons: false
                                                },
                                                handlers: {
                                                    handlerSave: profileHasAccess ? handlerSave : null,
                                                    handlerSaveAll: profileHasAccess ? handlerSaveAll : null,
                                                    handlerDelete: profileHasAccess ? handlerDelete : null,
                                                    handlerCancel: profileHasAccess ? handlerCancel : null,
                                                },
                                                auxiliarListCallbackOnAdd: null,
                                            }}
                                            inputParam_ExternalExportTemplates={[
                                                {
                                                    id: 'btnMantGetTemplate',
                                                    key: 'btnMantGetTemplate',
                                                    text: t('data-lang-lbl-uploadtemplate'),
                                                    iconProps: { iconName: 'ExcelDocument' },
                                                    onClick: () => handlerExportData(false)
                                                }
                                            ]}
                                            showRequiredMessage={showRequiredGlobalMessage}
                                        />
                                    </Col>
                                    <Col className={"text-end col-auto"}>
                                        {
                                            !loading && false &&
                                            <ActionButton iconProps={{iconName: "ServerProcesses"}} text={t('data-lang-btn-executeselectedintegrations')} onClick={handlerExecuteIntegrations} />
                                        }
                                        {
                                            loading &&
                                            <Loading
                                                inputParam_ShowLoading={true}
                                                inputParam_ShowText={true}
                                                inputParam_Text={t('data-lang-lbl-executing')}
                                                inputParam_Width={'35px'}
                                                inputParam_Height={'35px'}
                                                inputParam_Left={""}
                                                inputParam_Style={{marginTop: 0}}
                                                inputParam_ColClassName={"me-2"}
                                                inputParam_MarginLeft={"auto"}
                                                inputParam_SpinnerSize={SpinnerSize.medium}
                                                inputParam_Vertical={false}
                                            />
                                        }
                                    </Col>
                                </Row>
                                <JqxGrid
                                    ref={gridRef}
                                    altrows={false}
                                    enabletooltips={true}
                                    width={'100%'}
                                    theme={'light'} 
                                    editable={true}
                                    height={"550px"}
                                    sortable={true}
                                    filterable={true}
                                    showfilterrow={true} 
                                    localization={getGridLocalization(t)}
                                    source={ new jqx.dataAdapter({
                                        localData: listItems,
                                        dataType: 'array',
                                        dataFields: [            
                                            { name: 'id',         type: 'int' },
                                            { name: 'selection',  type: 'bool' },
                                            { name: 'integrationReportCode', type: 'string' },
                                            { name: 'uri',        type: 'string' },
                                            { name: 'params',     type: 'string' },
                                            { name: 'dateFormat', type: 'string' },
                                            { name: 'active',     type: 'bool' }
                                        ],
                                        id: 'id'
                                    })}
                                    columns={getColumns()}
                                    onCellvaluechanged={onCellvaluechanged} 
                                    onFilter={(event) => handlerFilter(event, 'IntegrationReport')}
                                />
                            </>
                        }
                    </div>
                </Card.Body>
            </Card>           
        </div>
    ); 
}

